export const queryKeys = {
  products: {
    all: ['products'] as const,
    list: (solutionId?: string) => ['products', solutionId] as const,
  },
  orders: {
    all: ['orders'] as const,
    detail: (orderId: string, warehouseId?: string) =>
      ['orders', orderId, warehouseId] as const,
  },
  marketOrders: {
    all: ['market-orders'] as const,
    list: (solutionId: string) => ['market-orders', solutionId] as const,
  },
  presets: {
    all: ['marketplace-presets'] as const,
  },
  routes: {
    detail: (routeId?: string) => ['routes', routeId] as const,
    freight: (routeId?: string) => ['routes', routeId, 'freight'] as const,
  },
  quickstart: {
    all: ['quickstart'] as const,
    recents: (productId?: string, sell?: boolean) =>
      ['quickstart', 'recents', productId, sell] as const,
    presets: (productId?: string, sell?: boolean) =>
      ['quickstart', 'presets', productId, sell] as const,
    tenderRecents: (solutionId?: string, sell?: boolean, division?: string) =>
      ['quickstart', 'tender-recents', solutionId, sell, division] as const,
  },
  banners: {
    all: ['banners'] as const,
    list: (solutionId?: string) => ['banners', 'list', solutionId] as const,
    schema: () => ['banners', 'schema'] as const,
    editSchema: (bannerId: string) =>
      ['banners', 'editSchema', bannerId] as const,
    display: (solutionId?: string) =>
      ['banners', 'display', solutionId] as const,
  },
};
